import { UserActivityLogModel } from 'src/app/shared/models/userActivityLog.model';
//import { inherits } from 'util';
import { OrganizationModel } from './organization.model';

export class GroupUserModel {
    
    users: UserModel[] = [];   
    deletedUsers?: UserModel[] = [];
 }

 export class GroupModel extends GroupUserModel {
    organizationId:string;
    groupId:string;
    groupName: string;
    groupDescription:string;
    isActive: boolean;    
    isSelected: boolean;   
    isDefault:boolean=false; 
    userActivityLog? : UserActivityLogModel;
 }

 export class UserModel {
     userId: string;
     fullName: string;    
     isDeleted:boolean;
     email:string; 
     userTypeDesc: string;   
     organizationId:string;
 }

export class UserGroupModel extends UserModel{
    groupId:string;
    groupName: string;
    groupDescription:string;
    userTypeId:string;
    userTypeDesc: string;
    isselected:boolean=false;
    isactive:boolean;
    //user and configurev below property for multiselect dropdown binding
    id:number;
    itemName:string;
    //
    userActivityLog : UserActivityLogModel;
}

export class UserGroupDataModel{
    users: UserGroupModel[] = [];
    groups: GroupModel[] = [];
    userActivityLog? : UserActivityLogModel;
}


export class TemplateShareDataModel extends UserGroupDataModel
{
organizations:OrganizationModel[]=[];
}

 